export const routes = (prefix = `lab`) => [
    {
        path: `/${prefix}/previous-results`,
        name: `${prefix}.previous-results.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.previous-results.index`,
                PageDescription: "Lab: Patient previous lab results",
            },
        },
    },
    {
        path: `/${prefix}/previous-results/:patientID`,
        name: `${prefix}.previous-results.view`,
        component: () => import('./View.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.previous-results.index`,
                PageDescription: "Lab: Patient previous lab results",
            },
        },
    },
];
